import gsap from 'gsap'

const RotatingTextBlock = {
  el: {
    root: document.querySelectorAll('.rotating-text-block'),
  },

  init() {
    if (this.el.root) {
      this.el.root.forEach((target) => {
        const el = {
          container: target.querySelector<HTMLDivElement>('.rotating-text-block__container'),
          list: target.querySelector<HTMLDivElement>('.rotating-text-block__list'),
          duplicatedList: target.querySelector<HTMLDivElement>('.rotating-text-block__list-duplicate'),
          words: target.querySelector<HTMLDivElement>('.rotating-text-block__words'),
        }

        this.duplicateWords(el)
        window.addEventListener('resize', () => {
          this.resetWords(el)
        })
      })
    }
  },

  animateContainer(el) {
    const listWidth = el.list.getBoundingClientRect().width

    const animation = gsap.timeline().fromTo(
      el.container,
      {
        x: 0,
      },
      {
        duration: 6,
        ease: 'none',
        overwrite: true,
        repeat: -1,
        x: -listWidth,
      }
    )

    const listWidthModifier = listWidth / window.innerWidth
    const screenWidthModifier = 100 / (window.innerWidth / 5)
    const speed = (1 / listWidthModifier) * screenWidthModifier

    animation.timeScale(speed)
  },

  duplicateWords(el) {
    const windowWidth = window.innerWidth
    const listWidth = el.list.getBoundingClientRect().width

    if (listWidth < windowWidth) {
      el.list.insertAdjacentHTML('beforeend', el.words.outerHTML)
      const newListWidth = el.list.getBoundingClientRect().width
      if (newListWidth < windowWidth) {
        this.duplicateWords(el)
      } else {
        this.duplicateList(el)
      }
    } else {
      this.duplicateList(el)
    }
  },

  duplicateList(el) {
    el.duplicatedList.innerHTML = el.list.innerHTML
    this.animateContainer(el)
  },

  resetWords(el) {
    el.list.innerHTML = el.words.outerHTML
    el.duplicatedList.innerHTML = ''
    this.duplicateWords(el)
  },
}

export default RotatingTextBlock
